import React from 'react';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import {Theme} from '@material-ui/core';
import HdaeTheme from '../common/HdaeTheme';
import EditAdButton from './EditAdButton';
import AdStatusChip from './AdStatusChip';
import AdFileOps from './AdFileOps';
import {JsonAdSummary} from '../../ext/lib/types';
import {LinkProps} from 'react-router-dom';
import {Link} from 'react-router-dom';
import {User, userEmail} from '../common/UserContext';
import {useEffect, useState} from 'react';
import {displayAdCost} from '../../ext/billing';
import {displayDateTime, parseJsonDateTime} from '../../ext/lib/temporal';
import {handleResponse} from '../../ext/common/rest-api-helper';
import {makeStyles} from '@material-ui/core'
import * as R from 'ramda';

type MaybeAds = JsonAdSummary[] | null;

type ListAdsProps = {user: User|undefined; apiToken: string|undefined}

// TODO: Fix forwardRef issue
// eslint-disable-next-line react/display-name
const AdapterLink = React.forwardRef<HTMLAnchorElement, LinkProps>(
  (props, ref) =>
    <Link innerRef={ref} {...props} />
);

const useStyles = makeStyles((theme: Theme) => ({
  button: {
    margin: theme.spacing(1)
  }
}));

const ListUserAds: React.FC<ListAdsProps> = ({user, apiToken}) => {
  const [ads, setAds] = useState(null as MaybeAds);
  const classes = useStyles(HdaeTheme);

  // TODO: Simplify with useApi hook
  useEffect(() => {
    const loadAds: (_: User|undefined) => void = R.pipe(
      R.tap(_user => console.info('fetching ads for user: %o', _user)),
      R.ifElse(R.isNil,
        R.pipe(R.always(Promise.resolve([])), R.andThen(setAds)),

        R.pipe(
          userEmail,
          btoa,
          userKey =>
            fetch(`/api/v1/requests/${userKey}`, {
              headers: {
                Authorization: apiToken || 'missing-token'
              }
            }),
          R.andThen(handleResponse as (_: Response) => Promise<JsonAdSummary[]>),
          R.andThen(setAds),
          R.otherwise(err => {
            console.error('Unable to fetch ads: %o', err);
            alert('Unable to get your ads. Reload the page and try again, or contact support.');
          })
        ))
      );

    loadAds(user);
  }, [user, apiToken]);

  const handleInvoice: React.MouseEventHandler = R.pipe(
    R.pathOr<string>('missing-key', ['currentTarget', 'dataset', 'key']),
    key =>
      window.location.href = `/invoice/${encodeURIComponent(key)}`
  );

  const renderList = R.cond([
    [R.isNil, R.always(<div className="loading-spinner"></div>)],
    [R.isEmpty, (): React.ReactElement => <h1>You haven&apos;t submitted any ads yet.</h1>],
    [R.T, (ads: JsonAdSummary[]): React.ReactElement =>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Status</TableCell>
            <TableCell>Submitted</TableCell>
            <TableCell>Ad</TableCell>
            <TableCell align="right">Price</TableCell>
            <TableCell></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {ads.map((ad: JsonAdSummary) => (
            <TableRow key={ad.adKey}>
              <TableCell><AdStatusChip ad={ad} /></TableCell>
              <TableCell>{displayDateTime(parseJsonDateTime(ad.orderedAt))}</TableCell>
              <TableCell>{ad.adName}</TableCell>
              <TableCell align="right">{displayAdCost(ad)}</TableCell>
              <TableCell align="right">
                <AdFileOps
                  userEmailAddress={userEmail(user)}
                  userAuthToken={apiToken || 'missing-token'}
                  adKey={ad.adKey}
                  adFileKey={ad.adFileKey}
                />
                <EditAdButton adKey={ad.adKey} isEnabled={!ad.programmedAt} />
                <Button
                  className={classes.button}
                  type="button"
                  color="primary"
                  variant="outlined"
                  data-key={ad.adKey}
                  onClick={handleInvoice}
                >Invoice</Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>]
  ]) as (_: MaybeAds) => React.ReactElement;

  return (
    <Paper>
      <Button component={AdapterLink} to="/new" style={{float: 'right', margin: '15px'}} variant="contained" color="primary">Submit New Ad</Button>
      <h2 style={{padding: '15px'}}>Submitted Ads</h2>
      {renderList(ads)}
    </Paper>
  );
};
export default ListUserAds;
